export enum MailListType {
  White = 'White',
  Block = 'Block',
}
